module.exports = __webpack_public_path__ + "9a0cfeda5ce5de1674106cd0a66ed55e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanslight.woff
// module id = 686
// module chunks = 57